var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightbulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33325 14.6667H9.66659M6.66659 6.66671H9.33325M7.99992 6.66671V10.6667M9.99992 10.2176C11.5765 9.46864 12.6666 7.86164 12.6666 6.00004C12.6666 3.42271 10.5773 1.33337 7.99992 1.33337C5.42259 1.33337 3.33325 3.42271 3.33325 6.00004C3.33325 7.86164 4.42329 9.46864 5.99992 10.2176V10.6667C5.99992 11.288 5.99992 11.5986 6.10141 11.8436C6.23674 12.1703 6.49631 12.4299 6.82299 12.5652C7.06805 12.6667 7.37865 12.6667 7.99992 12.6667C8.62119 12.6667 8.93179 12.6667 9.17685 12.5652C9.50352 12.4299 9.76312 12.1703 9.89845 11.8436C9.99992 11.5986 9.99992 11.288 9.99992 10.6667V10.2176Z",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.b2c0f51e9ac3ee1fd1912b6ec49127da.svg";
export { ForwardRef as ReactComponent };